<template>
    <div  class="header" style="position: fixed; bottom: 0; width:100%;">
        <b-container>
            <b-row>
              <b-col>Servicing: Weber, Davis, Salt Lake, and Morgan Counties</b-col>
              <b-col>Call: 801-546-0844</b-col>
              <b-col>Text: 801-546-0844</b-col>
              <b-col>Email: paul@waterscontracting.com</b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    export default {
        name: 'Footer',
    };
</script>